import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function SalesTraining() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/departments">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Sales Training
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>
                Sales interaction for <br /> Edge Live
              </h2>
              <img
                className="exp-img"
                src="/assets/images/sales-iot-img.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/sales-interaction">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Mahindra Loan <br /> Sales Chatbot
              </h2>
              <img
                className="exp-img"
                src="/assets/images/loan.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/mahindra-loan">
                <p>Open</p>
              </Link>
            </div>

            <div className="exp">
              <h2>
                Hindware bathware <br /> sales chatbot
              </h2>
              <img
                className="exp-img"
                src="/assets/images/bath-sales.png"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/hindware-bath-sales">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>
                New Dealer <br /> Sales Chatbot
              </h2>
              <img
                className="exp-img"
                src="/assets/images/dealer.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/hindware-dealer">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Software Sales</h2>
              <img
                className="exp-img"
                src="/assets/images/dealer.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/software-sales">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Whiteoak Sales Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/sales-chatbot.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/sales-chatbot">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
